(function () {
    var cartEndpoint = '/cart.js';
    var cartAddEndpoint = '/cart/add.js';
    var cartChangeEndpoint = '/cart/change.js';
    var cartUpdateEndpoint = '/cart/update.js';

    var cachedCart = null;
    var inflightCartPromise = null;

    function hydrateFromWindow() {
        if (cachedCart || typeof window === 'undefined') return;
        if (window.__CART__) {
            cachedCart = window.__CART__;
        }
    }

    function fetchCart(options) {
        var opts = options || {};
        var forceRefresh = opts.forceRefresh === true;
        hydrateFromWindow();

        if (!forceRefresh && cachedCart) {
            return Promise.resolve(cachedCart);
        }

        if (!forceRefresh && inflightCartPromise) {
            return inflightCartPromise;
        }

        inflightCartPromise = fetch(cartEndpoint, { credentials: 'same-origin' })
            .then(function (resp) {
                inflightCartPromise = null;
                if (!resp.ok) throw new Error('Unable to load cart.');
                return resp.json();
            })
            .then(function (cart) {
                cachedCart = cart;
                return cart;
            })
            .catch(function (err) {
                inflightCartPromise = null;
                throw err;
            });

        return inflightCartPromise;
    }

    function invalidateCart() {
        cachedCart = null;
    }

    function postJson(url, payload) {
        return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload || {})
        }).then(function (resp) {
            if (!resp.ok) {
                return resp.text().then(function (text) {
                    throw new Error(text || 'Request failed');
                });
            }
            invalidateCart();
            return resp.json ? resp.json() : null;
        });
    }

    function addItem(variantId, options) {
        var opts = options || {};
        var payload = {
            id: variantId,
            quantity: opts.quantity || 1
        };

        if (opts.properties) payload.properties = opts.properties;

        return postJson(cartAddEndpoint, payload);
    }

    function changeLineByKey(lineKey, quantity) {
        return postJson(cartChangeEndpoint, { id: lineKey, quantity: quantity });
    }

    function updateCart(payload) {
        return postJson(cartUpdateEndpoint, payload);
    }

    window.CartApi = {
        fetchCart: fetchCart,
        addItem: addItem,
        changeLineByKey: changeLineByKey,
        updateCart: updateCart,
        invalidateCart: invalidateCart
    };
})();
